import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ApplicationStore, ApplicationStoreType } from '../core/store/application.store';
import { UserService } from '../core/services/user.service';
import { ChainService } from '../core/services/chain.service';
import { AppUrls } from '../routing/app-urls';
import { CurrencyInfo } from '../shared/types/currency';
import { environment } from '../../environments/environment';

declare const heap: any;

@Component({
    selector: 'juyo-shell-layout',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, SidebarComponent],
    styleUrl: 'shell.layout.scss',
    template: `
        <juyo-sidebar [collapsed]="collapsed()" (toggled)="onToggle()" />
        <div class="content">
            <router-outlet />
        </div>
    `,
})
export class ShellLayout {
    private applicationStore: ApplicationStoreType = inject(ApplicationStore);
    private userService = inject(UserService);
    private chainService = inject(ChainService);
    private router = inject(Router);

    protected readonly collapsed = signal(false);

    constructor() {
        if (!this.applicationStore.signedInUser()) {
            this.userService.loadUser().subscribe({
                next: (user) => {
                    if (user && environment.heapId) {
                        heap.identify(user.id);
                        heap.addUserProperties({
                            email: `${user.email.toLowerCase()}`,
                            department: user.department,
                        });
                    }
                }
            });
        }
        this.chainService.loadChains().subscribe((chains) => {
            if (!chains || chains.length === 0) {
                this.router.navigate([AppUrls.noAccessUrl]);
            }
        });

        effect(() => {
            const chains = this.applicationStore.chains();
            if (!chains || chains.length === 0) return;
            if (this.applicationStore.selectedChain()) return;

            const chainIdParam = this.router.routerState.snapshot.root.queryParams['chainId'];
            const match = chainIdParam ? chains.find((c) => c.id === Number(chainIdParam)) : null;
            const chainToSelect = match ?? chains[0];

            this.applicationStore.setSelectedChain(chainToSelect);
            this.router.navigate([], {
                queryParams: { chainId: chainToSelect.id },
                queryParamsHandling: 'merge',
            });
        });

        // effect(() => {
        //     const selectedChain = this.applicationStore.selectedChain();
        //
        //     if (selectedChain) {
        //         this.chainService.loadCurrency(selectedChain.id).subscribe({
        //             next: (currencyContract) => {
        //                 if (currencyContract) {
        //                     const currencyInfo = new CurrencyInfo(
        //                         currencyContract.defaultCurrency.code,
        //                         currencyContract.defaultCurrency.sign,
        //                     );
        //                     this.applicationStore.setCurrencyInfo(currencyInfo);
        //                 }
        //             },
        //             error: (error) => {
        //                 console.log(error);
        //             },
        //         });
        //     }
        // });
    }

    protected onToggle(): void {
        this.collapsed.update((c) => !c);
    }
}
